module.exports = __webpack_public_path__ + "img/202408_01_sp.de342e84.jpg";